<template>
  <div v-if="imgLoading" class="gridcha-loading">
    <div class="xl-button__text">
      <i class="xl-button__loading"></i>
    </div>
  </div>
  <div class="zy-gridcha-box" v-else-if="imgs.length > 0" @touchmove.prevent>
    <div class="gridcha-que" v-if="que">{{ que }}</div>
    <div class="gridcha-tip" :class="{ 'success': verifySuccess }" v-if="tip">{{ tip }}</div>
    <div class="gridcha-imgs" :class="'imgs-' + imgs.length">
      <div class="gridcha-img" :class="{ 'actived': item.actived }" @click="clickImg(index)"
        v-for="(item, index) in imgs" :key="index" :style="{ backgroundImage: `url(${item.url})` }">
        <i class="xl-icon icon iconfont" v-if="item.actived" style="font-size: 32px; line-height:32px;color: #FFFFFF">
          <Wancheng />
        </i>
      </div>
    </div>
    <div class="gridcha-btn" @click="check">{{ btnText }}</div>
    <div class="gridcha-bottom">
      <button class="xl-button xl-button__text xl-button__small gridcha-cancel-btn" @click="close" type="button" >
        <span>{{ $t('authorize.authcancel') || '取消' }}</span>
      </button>
      <button class="xl-button xl-button__text xl-button__small gridcha-bottom-btn" :class="{'is-loading': loading}" @click="gotoNext" type="button" >
        <i v-if="loading" class="xl-button__loading"></i>
        <span>{{ $t('confirmText') || '确认' }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import { get } from 'lodash'
import { useLang, useIndependentLang } from "../util/lang";
import { Wancheng } from '@shining3d/icons-vue';
import { Base64 } from 'js-base64';
// const Base64 = require('js-base64');

const props = defineProps({
  reload: {
    type: Boolean,
    default: false
  },
  scene: {
    type: String,
    default: 'register'
  },
  imgLoading: {
    type: Boolean,
    default: false
  },
  customLang: String
});

let { $t } = useLang("@shining3d/xl-login");
if ( props.customLang ) {
  $t = useIndependentLang("@shining3d/xl-login", props.customLang).$t;
}

const emit = defineEmits(['resetInit', 'captchaCheckBack', 'zyShakeShow', 'close']);

const clickImg = (index) => {
  const actived = imgs.value[index].actived
  if (actived) {
    imgs.value[index].actived = false;
  } else {
    imgs.value[index].actived = true;
  }
}
const loading = ref(false);
const reloadFn = () => {
  verifySuccess.value = false;
  verifyFail.value = false;
}

const imgs = ref([]);
const que = ref('');
const tip = ref('');

const STARTSTR = 'iVBORw0KGgoAAAANSUhEUgAAA';
const decode = (str) => {
  return Base64.decode(str.slice(STARTSTR.length));
}
const getImgUrl = (url) => {
  let str = url.toString();
  if (!str.startsWith('http')) {
    str = decode(str);
  }
  return str + '?x-oss-process=image/resize,w_100';
}

function isImageLoaded(imageUrl, callback) {
  var img = new Image();

  img.onload = function() {
    callback(true);
  };

  img.onerror = function() {
    callback(false);
  };

  img.src = imageUrl;
}

function initData(obj) {
  if (obj.imgs && obj.imgs.length > 0) {
    let checkFalg = true;
    try {
      const imgsTemp = obj.imgs.map((item) => {
        if ( item.toString().startsWith('http') || item.toString().startsWith(STARTSTR + 'aHR0')) {
          const url = getImgUrl(item);
          isImageLoaded(url, (res) => {
            if(!res && checkFalg){
              console.log('[ Err Reset 1 ] >' );
              // 防止触发2次
              checkFalg = false;
              reset();
            }
          });
          return { url };
        } else {
          return { url: 'data:image/png;base64,' + item };
        }
      });
      imgs.value = imgsTemp;
    } catch (error) {
      console.log('[ Err Reset 2 ] >', error );
      if(checkFalg){
        checkFalg = false;
        reset();
      }
    }
  }
  if (obj.que) {
    que.value = obj.que;
  } else {
    que.value = '';
  }
}
const verifySuccess = ref(false); // 是否验证成功
const verifyFail = ref(false); // 是否验证成功

const putFail = () => {
  verifyFail.value = true;
  const verifyFailTemp = $t('gridcha.verifyFail') || '验证失败，请重试！';
  showTip(verifyFailTemp);
  emit('zyShakeShow');
}

const showTip = (txt) => {
  tip.value = txt;
  setTimeout(() => {
    tip.value = '';
  }, 2000)
}

const gotoNext = () => {
  if(loading.value){
    return;    
  }
  const num = imgs.value.map((item, index) => item.actived ? index : -1).filter(item => item !== -1).toString();
  if (num) {
    statusChange(num)
  } else {
    const noSelect = $t('gridcha.noSelect') || '请选择图片';
    showTip(noSelect);
  }
}

const close = () => {
  emit('close');
}

const reset = () => {
  emit('resetInit', () => {
    reloadFn();
  }, true);
}

const statusChange = (num) => {
  loading.value = true;
  emit('captchaCheckBack', {
    data: num,
    callback: (res) => {
      if (!res) {
        // 抖动
        putFail();
        // 2s后重新获取，重置
        setTimeout(() => {
          loading.value = false;
          reset();
        }, 2000);
      } else {
        verifySuccess.value = true;
        const verifySuccessTemp = $t( 'gridcha.verifySuccess' ) || '验证成功！';
        showTip(verifySuccessTemp);
      }
    }
  })
}

defineExpose({ initData });
</script>
<style lang="scss" scoped>
.xl-icon svg {
  width: 1em;
  height: 1em;
}
.gridcha-img {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 8px;
  margin-right: 8px;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;

  &.actived {
    display: flex;
    align-items: center;
    justify-content: center;

    .xl-icon {
      position: relative;
      z-index: 1;

      :deep(svg path) {
        fill: #FFFFFF;
      }
    }

    &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
    }
  }
}

.gridcha-imgs {
  display: flex;
  flex-wrap: wrap;
  width: 320px;
  &.imgs-2,&.imgs-3,&.imgs-6,&.imgs-9{
    .gridcha-img:nth-child(3n) {
      margin-right: 0;
    }
  }
  &.imgs-4,&.imgs-5,&.imgs-7,&.imgs-8{
    width: 344px;
    .gridcha-img{
      width: 80px;
      height: 80px;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}

.gridcha-que {
  padding: 2px 4px;
  border-radius: 6px;
  background: #F7F8FA;
  margin-bottom: 8px;
  word-break: break-word;
  line-height: 22px;
  font-size: 14px;
}

.gridcha-bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.gridcha-tip {
  background: #FDEEEE;
  border-radius: 6px;
  padding: 4px 12px;
  line-height: 22px;
  font-size: 14px;
  margin-bottom: 8px;
  color: #E64C4C;

  &.success {
    background: #E7F9F3;
    color: #0FBD81;
  }
}

.gridcha-cancel-btn,
.gridcha-bottom-btn {
  min-width: 28px;
  height: 32px;
  padding: 0 12px;
  font-size: 14px;
  border-radius: 6px;
  outline: 0;
  align-items: center;
  -webkit-box-pack: center;
  display: inline-flex;
  justify-content: center;
  color: var(--primary-color, #5587FF);
  background: 0 0;
  border: none;
  margin: 0;
  margin-left: 8px;
}

.gridcha-cancel-btn {
  color: #737E99;
}
.gridcha-loading{
  width: 320px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .1);
  border-radius: 6px;
  .xl-button__text{
    display: flex;
    .xl-button__loading{
      display: inline-block;
      height: 16px;
      margin: 0;
    }
  }
}
</style>